import { render, staticRenderFns } from "./BookingTab.vue?vue&type=template&id=1b0a4e43&lang=pug&"
import script from "./BookingTab.vue?vue&type=script&lang=ts&"
export * from "./BookingTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports